import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { MdClose } from "react-icons/md";

import ContainedButton from "components/layout/form/containedButton";

import theme from "styles/theme";
import {
  Alert,
  Container,
  ContainerButtons,
  ContentAlertIcon,
  ModalHeader,
  ModalStyle,
} from "./styles";

interface IDebitAlertModal {
  openModal: boolean;
  modalFunction: React.Dispatch<React.SetStateAction<boolean>>;
}

const DebitAlertModal = ({
  openModal,
  modalFunction,
}: IDebitAlertModal): JSX.Element => {
  const text =
    "<p>Para finalizar esta operação, daqui a dois dias úteis, estará disponível no canal digital de seu banco ou caixa eletrônico a <strong>confirmação</strong> de adesão ao débito automático. <strong>Somente após essa confirmação o cadastro em débito automático estará concluido.</strong></p>";

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Importante</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <ContentAlertIcon>
          <FiAlertTriangle />
        </ContentAlertIcon>
        <Alert dangerouslySetInnerHTML={{ __html: text }} />
        <ContainerButtons>
          <ContainedButton
            onClick={() => modalFunction(false)}
            color={theme.colors.darkYellow}
          >
            Estou ciente!
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default DebitAlertModal;
